import { Component, inject } from '@angular/core';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-settings-page',
  standalone: true,
  templateUrl: './settings-page.component.html'
})
export class SettingsPageComponent {
    protected readonly i18n = inject(TranslationService);
}